/* global module:false */
"use strict";

var $ = window.$;

var TPBS_ticker = (function(){
  var rtime;
  var timeout = false;
  var delta = 200;

  var resizeTicker = function(){
      if (new Date() - rtime < delta) {
        setTimeout(resizeTicker, delta);
      } else {
        timeout = false;
        var w = $('#breaking-news-ticker > .container').width() 
          - $('#breaking-news-ticker .title').outerWidth()
          - $('#breaking-news-ticker .close-btn').outerWidth();
        $('#news-ticker').width(w);
        $('#news-ticker .marquee').width(w);
      }
  };

  var init = function(){
    // news ticker
    if($('#news-ticker').size() > 0){
        $('#news-ticker marquee').marquee('marquee');
        $('#content').addClass('show-ticker');
        // wait for init
        setTimeout(function(){
            $('#breaking-news-ticker').removeClass('hide');
            resizeTicker();
        }, 300);

        $(window).resize(function(){
            //resizeTicker();
            rtime = new Date();
            if (timeout === false) {
                timeout = true;
                setTimeout(resizeTicker, delta);
            }
        });
        $('#breaking-news-ticker .close-btn').on('click', function(){
            $('#breaking-news-ticker').fadeOut();
            $('#content').removeClass('show-ticker');
        });
    }
  }
  return {
    init: init
  };
})();

module.exports = TPBS_ticker;
